"use client";

import {JSX} from "react";

import {useSnapshot} from "valtio";

import type {InquiryFormInstance} from "@/features/rental/inquiry-form/inquiry-form.model";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons";
import {FormNotify} from "@/shared/ui/form/form-submit-feedback";

import "./styles/inquiry-form-actions.scss";

export function InquiryFormActions({model, formId}: {model: InquiryFormInstance; formId: string}): JSX.Element {
    const {t} = useTranslation("booking");
    const snapshot = useSnapshot(model);

    if (snapshot.submitFeedback.isSuccess) return <></>;

    return (
        <>
            <ButtonBase type="submit" form={formId} variant="primary" size="lg-fixed" width="full" loading={snapshot.submitQuery.isPending}>
                {t("sendInquiry")}
            </ButtonBase>
            <p className="inquiry-form-actions__disclaimer">{t("inquiryDisclaimer")}</p>
            <FormNotify model={model.submitFeedback} />
        </>
    );
}
